import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home/Home";
import ExplorerClub from "./Pages/ExplorerClub/ExplorerClub";
import InfluencerClub from "./Pages/InfluencerClub/InfluencerClub";
import TripDiary from "./Pages/TripDiary/TripDiary";
import InfluencerRegistration from "./Pages/InfluencerRegistration/InfluencerRegistration";
import ExploreTrips from "./Pages/ExploreTrips/ExploreTrips";
import SingleTripPage from "./Pages/SingleTripPage/SingleTripPage";
import Header from "./Global/Header/Header";
import Footer from "./Global/Footer/Footer";
import PrivacyPolicy from "./Pages/FooterPages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./Pages/FooterPages/AboutUs/AboutUs";
import Terms from "./Pages/FooterPages/TermsAndConditions/Terms";
import WhatsappWidget from "./components/ui/WhatsappWidget/WhatsappWidget";
import Blogs from "./Pages/Blogs/Blogs";
import SingleBlogPage from "./Pages/Blogs/SingleBlogPage/SingleBlogPage";
import AdminPages from "./admin/Pages/AdminPages";

const App = () => {


  // const Loader = () => {

  //   return (
  //     <div className="flex flex-col items-center justify-center h-screen bg-red-50 bg-opacity-50 dark:bg-red-50">
  //       <div
  //         className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
  //         role="status"
  //       ></div>
  //       <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
  //         Loading ...
  //       </p>
  //     </div>
  //   );
  // };

  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/exploretrips" element={<ExploreTrips />} />
        <Route path="/explorerclub" element={<ExplorerClub />} />
        <Route path="/influencerclub" element={<InfluencerClub />} />
        <Route path="/tripdiary" element={<TripDiary />} />
        <Route
          path="/influencer-registration"
          element={<InfluencerRegistration />}
        />
        {/* No use , it was earlier demo page , now not hosted on backend */}
        {/* <Route path="/input-trips" element={<InputTrips />} /> */}
        <Route path="/trip/:tripId" element={<SingleTripPage />} />
        <Route
          path="/privacypolicy"
          element={
            <>
              <Header />
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="/aboutus"
          element={
            <>
              <Header />
              <AboutUs />
              <Footer />
            </>
          }
        />
        <Route
          path="/blogs"
          element={
            <>
              <Blogs />
            </>
          }
        />
        <Route path="/blog/:blogId/*" element={<SingleBlogPage />} />
        <Route
          path="/termsandconditions"
          element={
            <>
              <Header />
              <Terms />
              <Footer />
            </>
          }
        />
        <Route path="/*" element={<AdminPages />} />
      </Routes>
      <WhatsappWidget />
    </div>
  );
};

export default App;
